import { variacao } from "@bookdental/schemas";
import { Indicador } from "@/components/financeiro/visao/Indicadores";
import { fracao, horas, pct, type Ocupacao } from "./formato";

/** Os quatro números do mês, com a variação contra o mês anterior. */
export function IndicadoresDaOcupacao({ atual, anterior }: { atual: Ocupacao; anterior?: Ocupacao }) {
  const t = atual.total;
  const a = anterior?.total;
  const agendado = fracao(t.agendadoMin, t.expedienteMin);
  const real = fracao(t.realMin, t.realPossivelMin);
  const delta = (x: number | null, y: number | null | undefined) => (x === null || y == null ? null : variacao(x, y));
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Indicador
          c={{ rotulo: "Ocupação agendada", valor: pct(agendado), detalhe: `${horas(t.agendadoMin)} de ${horas(t.expedienteMin)}`, delta: delta(agendado, a && fracao(a.agendadoMin, a.expedienteMin)), bomSeSobe: true }}
        />
        <Indicador c={{ rotulo: "Uso real", valor: pct(real), detalhe: "dos dias até hoje", delta: delta(real, a && fracao(a.realMin, a.realPossivelMin)), bomSeSobe: true }} />
        <Indicador
          c={{ rotulo: "Atraso médio", valor: t.atrasoMedioMin === null ? "—" : `${t.atrasoMedioMin} min`, detalhe: "pra começar", delta: delta(t.atrasoMedioMin, a?.atrasoMedioMin), bomSeSobe: false }}
        />
        <Indicador c={{ rotulo: "Horas livres", valor: horas(t.livreMin), detalhe: "sem consulta no expediente", delta: delta(t.livreMin, a?.livreMin), bomSeSobe: false }} />
      </div>
      <p className="text-xs text-zinc-500 dark:text-muted-foreground">
        {t.faltas} {t.faltas === 1 ? "falta" : "faltas"} · {t.canceladas} {t.canceladas === 1 ? "cancelada" : "canceladas"} · {t.estouros}{" "}
        {t.estouros === 1 ? "passou do horário" : "passaram do horário"} · {t.semEncerramento} sem encerramento
      </p>
    </div>
  );
}
